import { useState } from "react";
import "./SelectList.css";
import Select from "react-select";

const SelectList = ({
  text,
  options,
  handleChange,
  property,
  valueAux = null,
  edicion,
  emptyInputs,
  styles,
  disabled,
  isFilter,
  fontBold,
  maxHeightMenu,
  menuPortal,
}) => {
  return (
    <div className="selectList" style={styles.additionalStyleDivSelectList}>
      {text && <label style={styles.fontStyleTitle}>{text}</label>}
      <Select
        styles={{
          input: (base) => ({
            ...base,
            color: "black",
            //color: text ? "black" : "white",
            fontWeight: fontBold ? "bold" : "normal",
            borderRadius: "5px",
            margin: "0px",
            paddingRight: "0.4rem",
            paddingLeft: "0.4rem",
            height: "34px",
          }),
          control: (base) => ({
            ...base,
            backgroundColor: disabled
              ? "rgb(236, 230, 230)"
              : text
              ? "white"
              : "#ccd9f6", // Aquí se aplica el color de fondo al input
            border: isFilter && "2px solid black", // <- grosor y color del borde
            boxShadow: "none", // <- evita el azul default al enfocar
            marginBottom: "-1px",
            textAlign: "center",
            "&:hover": {
              border: "2px solid black", // <- mantiene el borde al pasar el mouse
            },
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: maxHeightMenu ? maxHeightMenu : "",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          singleValue: (base) => ({
            ...base,
            color: disabled ? "rgb(63, 62, 61)" : "black",
            //color: disabled ? "rgb(63, 62, 61)" : text ? "black" : "white", // Color del texto dentro del input
            fontWeight: fontBold ? "bold" : "normal",
          }),
          option: (base) => ({
            ...base,
            fontWeight: fontBold ? "bold" : "normal",
          }),
        }}
        className="inputSelect"
        value={valueAux}
        options={options}
        isDisabled={edicion === "Edicion" || disabled ? true : false}
        //menuPlacement={text ? "bottom" : "top"}
        menuPlacement={"bottom"}
        menuPortalTarget={menuPortal ? document.body : undefined}
        menuPosition={menuPortal ? "fixed" : "absolute"}
        onChange={(value) => {
          handleChange({ label: value.label, value: value.value });
        }}
        components={{}}
      />
    </div>
  );
};

export default SelectList;